window.StikkmaCart=(()=>{
 'use strict';
 let busy=false,lastError='',opening=null;
 const context=()=>window.StikkmaHatLive;
 const variant=id=>context()?.variants[String(id).split('/').pop()];
 const endpoint=p=>(window.Shopify?.routes?.root||'/')+p;
 async function json(path,options={}){
  const response=await fetch(endpoint(path)+(options.method?'?kaching_cart_ignore=true':''),{...options,headers:{Accept:'application/json',...(options.body?{'Content-Type':'application/json'}:{}),...options.headers}});
  const data=await response.json();
  if(!response.ok)throw Error(data.description||data.message||'Deine Auswahl konnte gerade nicht in den Warenkorb gelegt werden.');
  return data;
 }
 const cart=()=>json('cart.js',{cache:'no-store'});
 function pendingUI(selector){
  const buttons=[...document.querySelectorAll('#stikkma-hats-v1 #add-to-cart,#stikkma-hats-v1 #mobile-add-to-cart,#stikkma-hats-v1 #standalone-add')];
  const previous=buttons.map(button=>({disabled:button.disabled,html:button.innerHTML}));
  for(const button of buttons){button.disabled=true;button.setAttribute('aria-busy','true');button.textContent='Wird hinzugefügt …';}
  const status=document.querySelector(selector);
  if(status){status.setAttribute('role','status');status.setAttribute('aria-live','polite');status.textContent='Wird in den Warenkorb hinzugefügt …';}
  return ()=>buttons.forEach((button,index)=>{button.disabled=previous[index].disabled;button.innerHTML=previous[index].html;button.removeAttribute('aria-busy');});
 }
 function details(modelId,config,group){
  const model=window.HatCollection.models.find(m=>m.id===modelId),font=window.CuscoCatalog.fonts.find(f=>f.id===config.font);
  const hasText=window.StikkmaPricing.hasText(config),hasMotif=window.StikkmaPricing.hasMotif(config);
  const props={Zusammenstellung:model?model.name+' · '+config.color:'Dein Bommel-Mix',_stikkmaMix:group,_stikkmaSchema:'hats-1'};
  if(hasText){props.Text=config.name.trim();props.Schrift=font?.name||config.font;props.Garnfarbe=window.CuscoCatalog.threads.find(t=>t.value===config.thread)?.name||config.thread;props['Garnfarbe HEX']=config.thread;}
  if(hasText)props['Schriftgröße']=Number.isFinite(config.textScale)?config.textScale+' % des Größenbereichs':(Number(config.textSize)||100)+' %';
  if(hasMotif){props.Motiv=window.StikkmaHatMotifs.label(config);props.Motivstil=window.StikkmaHatMotifs.styleLabel(config);props['Motiv-Anordnung']=hasText?({above:'Oberhalb',below:'Unterhalb',left:'Links',right:'Rechts'}[config.position]||'Oberhalb'):'Mittig';props['Motivgröße']=(config.motifSize||100)+' %';}
  if(hasText||hasMotif){
   const spec={version:1,model:modelId,color:config.color,name:hasText?config.name.trim():'',font:config.font,thread:config.thread,textScale:config.textScale,textPreviewSize:config.textPreviewSize,textMaxCuffWidth:.8,motifId:hasMotif?config.motifId:'none',motifStyle:config.motifStyle,libraryVersion:config.libraryVersion,position:config.position,motifSize:config.motifSize,manual:config.manual,motifX:config.motifX,motifY:config.motifY,...(modelId==='aquili'?{textSize:Number(config.textSize)||100,textPreviewSize:config.textPreviewSize,motifCoordinateSystem:config.motifCoordinateSystem}: {})};
   const encoded=JSON.stringify(spec);for(let i=0;i<encoded.length;i+=200)props['_Gestaltung_'+(i/200+1)]=encoded.slice(i,i+200);
  }
  return props;
 }
 function canBuyColor(modelId,label){
  const model=window.HatCollection?.models.find(m=>m.id===modelId),color=model?.colors.find(c=>c.id===label||c.label===label),row=context()?.models[modelId]?.find(r=>r.colorId===color?.id);
  return !!(row&&variant(row.variantId)?.available&&!color?.placeholder);
 }
 function itemsFor(input,group){
  const modelId=input.modelId,config=window.StikkmaHatMotifs?window.StikkmaHatMotifs.enrich(input.config):input.config;
  const qty=Math.max(1,Math.min(99,Math.floor(Number(input.quantity)||1))),data=context(),items=[],props=details(modelId,config,group);
  const add=(id,quantity,kind,extra={})=>{
   if(!quantity)return;const v=variant(id);if(!v?.available)throw Error('Diese Auswahl ist gerade nicht lieferbar. Bitte wähle eine andere Farbe.');
   if(v.tracked&&quantity>v.quantity)throw Error('Von dieser Variante sind nur noch '+v.quantity+' Stück verfügbar.');
   if(!Number.isSafeInteger(quantity)||quantity<1)throw Error('Bitte prüfe die gewünschte Anzahl.');
   items.push({id:String(id).split('/').pop(),quantity,properties:{...props,_stikkmaPart:kind,...extra}});
  };
  if(modelId!=='bommel'){
   const model=window.HatCollection.models.find(m=>m.id===modelId),color=model?.colors.find(c=>c.id===config.color||c.label===config.color),row=data?.models[modelId]?.find(r=>r.colorId===color?.id);
   if(!row)throw Error('Diese Farbe ist noch nicht für den Kauf verfügbar.');
   add(row.variantId,qty,'hat');
  }
  const quote=window.StikkmaPricing.quote(modelId,config),gift=quote.giftPom;
  if(modelId==='bommel'||window.HatCollection.models.find(m=>m.id===modelId)?.pomType==='removable')config.quantities?.forEach((count,index)=>{
   if(!count)return;const pom=window.CuscoCatalog.poms[index],row=data.poms.find(p=>p.index===index);if(!row||pom.active===false)throw Error('Dieser Bommel ist nicht mehr verfügbar.');
   const paid=count-(index===gift?1:0);add(row.variantId,paid*qty,'pom',{Bommel:pom.material+' '+pom.name});
   if(index===gift)add(row.variantId,1,'gift',{Bommel:pom.material+' '+pom.name,Geschenk:'Dein ausgewählter Basic-Bommel · ab 3 gekauften Bommeln'});
  });
  if(quote.textEmbroidery)add(data.fees.Textstick,qty,'text');
  if(quote.motifEmbroidery)add(data.fees.Motivstick,qty,'motif');
  return {items,quote,qty,gift,group};
 }
 function expectedLines(items){
  const rows=new Map();
  for(const item of items){
   const key=item.id+':'+item.properties._stikkmaPart;
   rows.set(key,(rows.get(key)||0)+item.quantity);
  }
  return rows;
 }
 function confirmedLines(items,expected){
  const actual=expectedLines(items.map(item=>({id:String(item.variant_id||item.id),quantity:item.quantity,properties:item.properties||{}})));
  return actual.size===expected.size&&[...expected].every(([key,count])=>actual.get(key)===count);
 }
 function discountCodes(value){return (value.discount_codes||[]).map(v=>typeof v==='string'?v:v.code).filter(Boolean);}
 async function restoreGroup(group,before,restoreDiscount){
  const current=await cart(),updates={};
  for(const line of current.items)if(line.properties?._stikkmaMix===group)updates[line.key]=0;
  if(Object.keys(updates).length||restoreDiscount){
   const body={updates};if(restoreDiscount)body.discount=discountCodes(before).join(',');
   await json('cart/update.js',{method:'POST',body:JSON.stringify(body)});
  }
  const checked=await cart();
  if(checked.items.some(i=>i.properties?._stikkmaMix===group))throw Error('Die unvollständige Auswahl liegt noch im Warenkorb.');
 }
 async function add(input){
  if(busy){lastError='Deine Auswahl wird gerade in den Warenkorb gelegt.';return false;}
  busy=true;lastError='';const group=crypto.randomUUID();let before=null,mutated=false,discountChanged=false;
  const buttons=[...document.querySelectorAll('#stikkma-hats-v1 #add-to-cart,#stikkma-hats-v1 #mobile-add-to-cart,#stikkma-hats-v1 #standalone-add')];
  const disabled=buttons.map(b=>b.disabled);buttons.forEach(b=>{b.disabled=true;b.setAttribute('aria-busy','true');});
  try{
   const plan=itemsFor(input,group);if(!plan.items.length)throw Error('Wähle zuerst deine Lieblingsstücke aus.');
   before=await cart();
   if(plan.gift>=0&&before.items.some(i=>i.properties?._stikkmaPart==='gift'))throw Error('Dein Gratis-Basic liegt bereits im Warenkorb. Pro Bestellung gibt es ein Geschenk. Entferne den zusätzlichen Gratis-Bommel aus diesem Mix.');
   const counts=new Map();
   for(const item of plan.items)counts.set(item.id,(counts.get(item.id)||0)+item.quantity);
   for(const [id,count]of counts){const v=variant(id);if(v.tracked&&count>v.quantity)throw Error('Von dieser Variante sind nur noch '+v.quantity+' Stück verfügbar.');}
   mutated=true;
   await json('cart/add.js',{method:'POST',body:JSON.stringify({items:[...plan.items].reverse()})});
   if(plan.gift>=0){
    const chosen=window.CuscoCatalog.poms[plan.gift],code=chosen.id==='style-KF129'?'STIKKMA-BASIC-GESCHENK':'STIKKMA-BASIC-HELL-GESCHENK';
    const codes=discountCodes(before).filter(v=>!/^STIKKMA-BASIC(?:-HELL)?-GESCHENK$/i.test(v));codes.push(code);
    discountChanged=true;
    await json('cart/update.js',{method:'POST',body:JSON.stringify({discount:codes.join(',')})});
   }
   const after=await cart(),added=after.items.filter(i=>i.properties?._stikkmaMix===group);
   if(!confirmedLines(added,expectedLines(plan.items)))throw Error('Mütze und Zubehör konnten nicht vollständig bestätigt werden. Deine neue Auswahl wird zurückgenommen.');
   const expectedPrice=Math.round(plan.quote.total*plan.qty*100);
   const addedPrice=added.reduce((sum,i)=>sum+i.final_line_price,0);
   if(addedPrice>expectedPrice+1)throw Error('Der Warenkorbpreis stimmt nicht mit deiner Auswahl überein. Deine neue Auswahl wird zurückgenommen.');
   if(plan.gift>=0&&added.filter(i=>i.properties._stikkmaPart==='gift').some(i=>i.final_line_price!==0))throw Error('Der Gratis-Bommel konnte nicht als Geschenk bestätigt werden. Deine neue Auswahl wird zurückgenommen.');
   try{
    const preview={hat:input.image?.startsWith('data:image/jpeg;base64,')&&input.image.length<200000?input.image:'',detail:input.detailImage?.startsWith('data:image/jpeg;base64,')&&input.detailImage.length<800000?input.detailImage:'',poms:{}};
    for(const item of plan.items)if(['pom','gift'].includes(item.properties._stikkmaPart)){
     const row=context().poms.find(p=>String(p.variantId)===String(item.id)),pom=window.CuscoCatalog.poms[row?.index];
     if(pom)preview.poms[item.id]=window.StikkmaHatAssets.resolve(pom.cutout||pom.src);
    }
    window.StikkmaHatCartPreviews??={};window.StikkmaHatCartPreviews[group]=preview;
    document.dispatchEvent(new CustomEvent('stikkma:hat-cart-preview'));
    try{localStorage.setItem('stikkma-hat-cart-'+group,JSON.stringify(preview));
     if(preview.hat)localStorage.setItem('stikkma-hat-preview-'+group,preview.hat);
    }catch{}
   }catch{}
   return {saved:true,group,cart:after};
  }catch(error){
   lastError=error.message||'Bitte versuche es erneut.';
   if(mutated&&before){
    try{await restoreGroup(group,before,discountChanged);}
    catch{lastError='Die Übertragung wurde unterbrochen. Bitte prüfe deinen Warenkorb, bevor du die Auswahl erneut hinzufügst.';await open();}
   }
   if(window.kachingCartApi?.refreshCart)try{await window.kachingCartApi.refreshCart();}catch{}
   return false;
  }finally{busy=false;buttons.forEach((b,i)=>{b.disabled=disabled[i];b.removeAttribute('aria-busy');});}
 }
 async function showDrawer(){
  // Egling keeps its existing service validation on the full basket page.
  if(document.getElementById('stikkma-egling-cart-style')?.textContent.includes('#kaching-cart{display:none')){
   location.assign(endpoint('cart'));return true;
  }
  if(window.kachingCartApi?.openCart){
   try{window.kachingCartApi.openCart({refetchCart:true});return true;}catch{}
  }
  const drawer=document.getElementById('cart-drawer');
  if(drawer?.show){
   await new Promise(resolve=>{
    let timer;
    const finish=()=>{clearTimeout(timer);drawer.removeEventListener('cart-drawer:refreshed',finish);resolve();};
    drawer.addEventListener('cart-drawer:refreshed',finish,{once:true});timer=setTimeout(finish,2500);
    document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
   });
   await drawer.show();return true;
  }
  const trigger=document.querySelector('a[href="'+endpoint('cart')+'"]');
  if(trigger){trigger.click();return true;}
  return false;
 }
 function open(){
  if(opening)return opening;
  opening=showDrawer().finally(()=>{opening=null;});return opening;
 }
 return {add,open,pendingUI,canBuyColor,render(){},price:e=>window.StikkmaPricing.quote(e.modelId,e.config),itemsFor,get busy(){return busy;},get lastError(){return lastError;}};
})();
